import { Form, Formik } from 'formik'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Button from '../../components/Button'
import ButtonBack from '../../components/ButtonBack'
import ErrorBox from '../../components/ErrorBox'
import Input from '../../components/Form/Input'
import Loading from '../../components/Loading'
import Spacing from '../../components/Spacing'
import { SupportText } from '../../components/Support'
import Text from '../../components/Text'
import { sendPasswordCode, validatePasswordCode } from '../../services/user'
import m from '../../utils/messages'
import { Container, OutlinedInputContainer } from './styles'

export const PasswordCode = () => {
  const history = useHistory();
  const credentials = useSelector(state => state.main.credentials);

  const [loadingResendCode, setLoadingResendCode] = useState(false);

  const [loaded, setLoaded] = useState(false);

  const [error, setError] = useState(null);

  const handleSendCode = async () => {
    setLoadingResendCode(true)
    await sendPasswordCode({ [credentials.field]: credentials.value });
    setLoadingResendCode(false)
  }

  const handleSubmit = async (data, { setSubmitting }) => {
    setSubmitting(true);
    setError(null);
    try {
      const { token } = await validatePasswordCode({
        [credentials.field]: credentials.value,
      }, data.code);
      setSubmitting(false);
      sessionStorage.setItem('@resetToken@', token);
      return history.push('/password/create');
    } catch (err) {
      setSubmitting(false);
      switch (err.code) {
        case "invalidCode":
          return setError('Código inválido');
        default:
          return setError(m('internalError'));
      }
    }
  }

  useEffect(() => {
    (async () => {
      if (!credentials) {
        history.replace('/login');
      } else {
        try {
          setLoaded(false)
          await sendPasswordCode({ [credentials.field]: credentials.value });
          setLoaded(true)
        } catch (err) {
          history.replace('/login');
        }
      }
    })()
  }, [history, credentials])

  return (
    <>
      <ButtonBack onClick={() => history.goBack()} />
      <Container>
        <ErrorBox error={error} />
        <Text variant="regular">
          Informe o Código de Acesso enviado para o e-mail <span className="semibold">{credentials?.publicValue || ''}:</span>
        </Text>

        {loaded ? (
          <>
            <Formik initialValues={{ code: '' }} onSubmit={handleSubmit}>
              {({ isSubmitting }) => (
                <Form className="form login__form">
                  <OutlinedInputContainer>
                    <Input variant="outlined" name="code" required />
                  </OutlinedInputContainer>
                  <Button variant="buttonPrimary" type="submit" loading={isSubmitting} text="Confirmar" />
                </Form>
              )}
            </Formik>
            <Spacing size={24} />
            <Text variant="regular" align="center">
              Aguarde alguns instantes para receber seu Código de acesso.
            </Text>
            <Spacing size={24} />
            <Text variant="regular" align="center">
              <span className="semibold">Não recebeu o Código de Acesso?</span>
            </Text>
            <Button
              variant="linkPrimary"
              loading={loadingResendCode}
              weight={500}
              align="center"
              text="Enviar novamente"
              onClick={handleSendCode}
            />
          </>
        ) : (
            <Loading />
          )}
        <SupportText />
      </Container>
    </>
  )
}
